

















































import { Vue, Component, Prop } from "vue-property-decorator";

// Types
import { IImport } from "@/models/imports";
import { Location } from "vue-router";

@Component
export default class ImportListItem extends Vue {
  // Props

  @Prop({ default: false })
  public isLoading!: boolean;

  @Prop({ default: null })
  public importObj!: IImport;

  // Methods

  public startingMessage() {
    if (!this.importObj.started_at) return { label: "--", showDate: false };

    return this.$moment(this.importObj.started_at)
      .local()
      .isAfter(new Date())
      ? { label: "Starts", showDate: true }
      : { label: "Started", showDate: true };
  }

  // Computed

  public get showSkeletons() {
    return this.$_.isNull(this.importObj);
  }

  public get importRoute(): Location {
    if (!this.importObj) return {};
    return {
      name: "adminImport",
      params: { importId: this.importObj.id }
    };
  }

  public get status() {
    return this.importObj?.status?.code;
  }
}
